import { ApiErrorCode } from 'shared/src/api/httpClient';

export const REGISTER_STATUS_CODE = {
  /** 이미 가입된 이메일/계정 (409) */
  AlreadyRegistered: ApiErrorCode.EMAIL_VALIDATION,
  /** 휴대폰 번호 필요/점유 (400) */
  NeedPhone: ApiErrorCode.PHONE_VALIDATION,
  /** 이메일 필요 (400) */
  NeedEmail: ApiErrorCode.EMAIL_NEEDED,
} as const;
